exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SWDf2 {\n  display: inline-block;\n  -ms-flex: 0 0 48px;\n      flex: 0 0 48px;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  background-color: #f2f2f2;\n  vertical-align: middle;\n  -webkit-margin-end: 12px;\n          margin-inline-end: 12px;\n}\n\n._3rdOH {\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n}\n\n._3rdOH:focus-visible {\n  outline: 2px solid #1a73e8;\n  outline-offset: 2px;\n}\n\n.sIGKh {\n  display: block;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n._2A-ij {\n  -o-object-fit: contain;\n     object-fit: contain;\n  padding: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"thumb": "SWDf2",
	"button": "_3rdOH",
	"image": "sIGKh",
	"placeholderImage": "_2A-ij"
};